import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress"; // Import a loading spinner from MUI
import Box from "@mui/material/Box"; // Import Box for layout

// Lazy load all components
const LoginPage = lazy(() => import("../Pages/LoginMgt/LoginPage"));
const MainHomeLayout = lazy(() => import("../Pages/MainHomeLayout"));
const DashboardPage = lazy(() => import("../Pages/Dashboard/DashboardPage"));
const Category = lazy(() => import("../Pages/Category/Category"));
const Products = lazy(() => import("../Pages/Products/Products"));
const Tables = lazy(() => import("../Pages/Tables/Tables"));
const Staff = lazy(() => import("../Pages/Staff/Staff"));
const PosLandingPage = lazy(() => import("../Pages/POS/PosLandingPage"));
const Kitechen = lazy(() => import("../Pages/Kitechen/Kitechen"));
const Reports = lazy(() => import("../Pages/Reports/Reports"));
const InverdLoader = lazy(() => import("../Pages/Inward/InverdLoader"));
const PricingPage = lazy(() => import("../Pages/Pricing/PricingPage"));
const Settings = lazy(() => import("../Pages/Settings/Settings"));
const DailySales = lazy(() => import("../Pages/Reports/DailySales"));
const LooseLiquorReport = lazy(() => import("../Pages/Reports/LooseLiquorReport"));
const Stock = lazy(() => import("../Pages/Reports/Stock"));
const Employee = lazy(() => import("../Pages/Reports/Employee"));
const Inward = lazy(() => import("../Pages/Inward/Inward"));
const Supplier = lazy(() => import("../Pages/Inward/Supplier"));
const PartyMGT = lazy(() => import("../Pages/Inward/PartyMGT"));
const Outward = lazy(() => import("../Pages/Outward/Outward"));
const BulkRateupdate = lazy(() => import("../Pages/Reports/BulkRateupdate"));
const Expenses = lazy(() => import("../Pages/Reports/Expenses"));

// Fallback component with centered loading spinner
const Fallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh" // Full viewport height
  >
    <CircularProgress /> {/* Material-UI loading spinner */}
  </Box>
);

const UserRoutes = () => {
  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<MainHomeLayout />}>
          <Route path="/dashboardpage" element={<DashboardPage />} />
          <Route path="/category" element={<Category />} />
          <Route path="/products" element={<Products />} />
          <Route path="/tables" element={<Tables />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/pos" element={<PosLandingPage />} />
          <Route path="/Kitchen" element={<Kitechen />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/inward" element={<InverdLoader />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/reports/dailysales" element={<DailySales />} />
          <Route path="/reports/looseliquor" element={<LooseLiquorReport />} />
          <Route path="/reports/stock" element={<Stock />} />
          <Route path="/reports/empreport" element={<Employee />} />
          <Route path="/reports/liqurereports" element={<Settings />} />
          <Route path="/reports/expenses" element={<Settings />} />
          <Route path="/inward/inward" element={<Inward />} />
          <Route path="/inward/supplier" element={<Supplier />} />
          <Route path="/inward/partymgt" element={<PartyMGT />} />
          <Route path="/outward" element={<Outward />} />
          <Route path="/reports/bulkrateupdate" element={<BulkRateupdate />} />
          <Route path="/reports/expensereport" element={<Expenses />} />
          <Route path="/reports/staffreport" element={<Employee />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default UserRoutes;